import { useEffect } from "react"
import { useLocation } from "react-router-dom"

const SITE_URL = "https://sdley.netlify.app"
const DEFAULT_METADATA = {
  title: "Souleymane Diallo | Ingénieur Logiciel & Développeur Fullstack",
  description:
    "Ingénieur logiciel, développeur fullstack spécialisé en Java, Spring Boot, Spring WebFlux, React, Next.js et Angular. Découvrez le portfolio de Souleymane Diallo.",
}

const PAGE_METADATA = {
  "/about": {
    title: "À propos | Ingénieur logiciel | Souleymane Diallo",
    description:
      "Découvrez le parcours de Souleymane Diallo, Ingénieur logiciel et développeur fullstack spécialisé en Java, Spring Boot, React, Next.js et Angular.",
  },
  "/portfolio": {
    title: "Projets Java, Spring Boot & React | Souleymane Diallo",
    description:
      "Explorez les projets de Souleymane Diallo, développeur fullstack : applications Java et Spring Boot, interfaces React, Next.js et Angular.",
  },
  "/services": {
    title: "Développement Java, Spring Boot & React | Services",
    description:
      "Services de développement fullstack : APIs Java avec Spring Boot et Spring WebFlux, applications React, Next.js et Angular conçues pour vos besoins métier.",
  },
  "/contact": {
    title: "Contacter un Développeur Fullstack Java | Souleymane Diallo",
    description:
      "Contactez Souleymane Diallo, Ingénieur logiciel spécialisé en Java, Spring Boot, Spring WebFlux, React, Next.js et Angular.",
  },
  "/activities": {
    title: "Activités | Souleymane Diallo",
    description:
      "Découvrez les activités, événements et réalisations qui ont marqué le parcours de Souleymane Diallo.",
  },
}

const setMetaContent = (selector, content) => {
  const element = document.head.querySelector(selector)

  if (element) {
    element.setAttribute("content", content)
  }
}

const Seo = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const normalizedPath = pathname === "/" ? "/" : pathname.replace(/\/$/, "")
    const metadata = PAGE_METADATA[normalizedPath] || DEFAULT_METADATA
    const canonicalUrl = `${SITE_URL}${normalizedPath === "/" ? "/" : normalizedPath}`
    const canonical = document.head.querySelector('link[rel="canonical"]')
    const isPrivateRoute = normalizedPath === "/create"

    document.title = metadata.title
    setMetaContent('meta[name="description"]', metadata.description)
    setMetaContent('meta[property="og:title"]', metadata.title)
    setMetaContent('meta[property="og:description"]', metadata.description)
    setMetaContent('meta[property="og:url"]', canonicalUrl)

    if (canonical) {
      canonical.setAttribute("href", canonicalUrl)
    }

    setMetaContent(
      'meta[name="robots"]',
      isPrivateRoute ? "noindex, nofollow" : "index, follow"
    )
  }, [pathname])

  return null
}

export default Seo
